export const getMaskedPhoneNumber = (phone: string | undefined) => {
    if (phone) {
        return `(***) ***-${phone.substring(phone.length - 4)}`
    }

    return ''
}
